import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import printPdf from 'utils/printPdf';
import qs from 'qs';
import { Helmet } from 'react-helmet';

import { groupBy, uniq, uniqBy } from 'lodash';

import { getFormValues, change, reset, clearFields, isSubmitting } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Paper from '@material-ui/core/Paper';

import Layout from 'components/common/Layout';
import Progress from 'components/common/Progress';
import NavigationFilter from 'components/workflow/NavigationFilter';
import OrdersFilter from 'components/workflow/OrdersFilter';
import ScheduleCalendarFilter from 'components/schedule/ScheduleCalendarFilter';
import ScheduleCalendar from 'components/schedule/ScheduleCalendar';
import StickyToolbar from 'components/common/StickyToolbar';

import { fetchOrders, clearOrders, updateOrderSuccess } from 'redux/modules/orders';
import { clearConnectedOrders } from 'redux/modules/connectedOrders';
import { fetchUsers, clearUsers } from 'redux/modules/users';
import { fetchPatientGlobalNotes } from 'redux/modules/patientsGlobalNotes';
import { clearPatients, fetchPatients } from 'redux/modules/patients';
import { fetchBusiness } from 'redux/modules/business';
import { addNotification } from 'redux/modules/notifications';

import scheduleToPDF from 'utils/scheduleToPDF';
import { getFilterChangeTypes } from 'utils/filterChangeTypes';
import objectDiff from 'utils/objectDiff';
import throttle from 'utils/throttle';
import * as validate from 'utils/validate';

import { appTitle, titleSeparator } from 'config/helmetSettings';
import dateFormat from 'config/dateFormat';
import timeDateFormat from 'config/timeDateFormat';

import OrdersTableEmpty from 'components/workflow/OrdersTable/OrdersTableEmpty';

const styles = () => ({
  expansionPanelDetails: {
    padding: 0,
  },
  paperOrdersEmpty: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
});

class DeliverySchedule extends Component {
  constructor(props) {
    super(props);

    this.state = {
      'Date of Delivery From': props.filters['Date of Delivery From'],
      'Date of Delivery To': props.filters['Date of Delivery To'],
      toolbarHeight: 0,
      toolbarExpanded: false,
      horizontalScroll: 0,
      limit: 10,
      offset: 0,
    };

    this.onRequest = this.onRequest.bind(this);
    this.onScheduleCalendarHorizontalScroll = this.onScheduleCalendarHorizontalScroll.bind(this);
    this.onToolbarResize = this.onToolbarResize.bind(this);
    this.onSequenceRequest = this.onSequenceRequest.bind(this);
    this.onWindowMessage = this.onWindowMessage.bind(this);

    this.onThrottledRequest = throttle(this.onRequest, 2000, false, true);
  }

  componentWillMount() {
    const { actions, location, history, variant, workflowOrdersFilterValues } = this.props;
    actions.clearUsers();
    actions.clearOrders();
    actions.clearConnectedOrders();
    document.querySelector('html').classList.add('page-schedule');
    if (!location.search) {
      let dateOfDeliveryFrom;
      let dateOfDeliveryTo;
      switch (variant) {
        case 'month':
          dateOfDeliveryFrom = moment().startOf('month').format(dateFormat);
          dateOfDeliveryTo = moment().startOf('month').add(1, 'month').subtract(1, 'day')
            .format(dateFormat);
          break;
        case 'week':
          dateOfDeliveryFrom = moment().startOf('week').format(dateFormat);
          dateOfDeliveryTo = moment().startOf('week').add(6, 'days').format(dateFormat);
          break;
        default:
          dateOfDeliveryFrom = moment().format(dateFormat);
          dateOfDeliveryTo = moment().format(dateFormat);
      }
      const datesOfDeliveryParams = qs.stringify({
        from: dateOfDeliveryFrom,
        to: dateOfDeliveryTo,
      }, {
        encode: false, addQueryPrefix: true,
      });
      if (location.state && location.state.fromWorkflow) {
        if (workflowOrdersFilterValues.Filters) {
          if (workflowOrdersFilterValues.Filters['Date of Delivery']
            && workflowOrdersFilterValues.Filters['Date of Delivery'][0]) {
            dateOfDeliveryFrom = workflowOrdersFilterValues.Filters['Date of Delivery'][0].value.split('-')[0];
            dateOfDeliveryTo = workflowOrdersFilterValues.Filters['Date of Delivery'][0].value.split('-')[1];
            actions.change('schedule-ordersFilter', 'Date of Delivery From', dateOfDeliveryFrom);
            actions.change('schedule-ordersFilter', 'Date of Delivery To', dateOfDeliveryTo);
            actions.change('schedule-ordersFilter', 'Filters.Date of Delivery', [{
              value: `${dateOfDeliveryFrom}-${dateOfDeliveryTo}`,
              label: `${dateOfDeliveryFrom}-${dateOfDeliveryTo}`,
            }]);
            history.replace(`${location.pathname}${datesOfDeliveryParams}`);
          } else {
            actions.clearFields('schedule-ordersFilter', 'Date of Delivery From');
            actions.clearFields('schedule-ordersFilter', 'Date of Delivery To');
            actions.change('schedule-ordersFilter', 'Filters.Date of Delivery', []);
          }
          if (workflowOrdersFilterValues.Filters['Date of Service']
            && workflowOrdersFilterValues.Filters['Date of Service'][0]) {
            const dateOfServiceFrom = workflowOrdersFilterValues.Filters['Date of Service'][0].value.split('-')[0];
            const dateOfServiceTo = workflowOrdersFilterValues.Filters['Date of Service'][0].value.split('-')[1];
            actions.change('schedule-ordersFilter', 'Date of Service From', dateOfServiceFrom);
            actions.change('schedule-ordersFilter', 'Date of Service To', dateOfServiceTo);
            actions.change('schedule-ordersFilter', 'Filters.Date of Service', [{
              value: `${dateOfServiceFrom}-${dateOfServiceTo}`,
              label: `${dateOfServiceFrom}-${dateOfServiceTo}`,
            }]);
          } else {
            actions.clearFields('schedule-ordersFilter', 'Date of Service From');
            actions.clearFields('schedule-ordersFilter', 'Date of Service To');
            actions.change('schedule-ordersFilter', 'Filters.Date of Service', []);
          }
          if (workflowOrdersFilterValues.Filters['Date of Claim Submission']
            && workflowOrdersFilterValues.Filters['Date of Claim Submission'][0]) {
            const dateOfClaimSubmissionFrom = workflowOrdersFilterValues.Filters['Date of Claim Submission'][0].value.split('-')[0];
            const dateOfClaimSubmissionTo = workflowOrdersFilterValues.Filters['Date of Claim Submission'][0].value.split('-')[1];
            actions.change('schedule-ordersFilter', 'Date of Claim Submission From', dateOfClaimSubmissionFrom);
            actions.change('schedule-ordersFilter', 'Date of Claim Submission To', dateOfClaimSubmissionTo);
            actions.change('schedule-ordersFilter', 'Filters.Date of Claim Submission', [{
              value: `${dateOfClaimSubmissionFrom}-${dateOfClaimSubmissionTo}`,
              label: `${dateOfClaimSubmissionFrom}-${dateOfClaimSubmissionTo}`,
            }]);
          } else {
            actions.clearFields('schedule-ordersFilter', 'Date of Claim Submission From');
            actions.clearFields('schedule-ordersFilter', 'Date of Claim Submission To');
            actions.change('schedule-ordersFilter', 'Filters.Date of Claim Submission', []);
          }
          if (workflowOrdersFilterValues['Claim Code']) {
            actions.change('schedule-ordersFilter', 'Claim Code', workflowOrdersFilterValues['Claim Code']);
          } else {
            actions.clearFields('schedule-ordersFilter', 'Claim Code');
          }
          if (workflowOrdersFilterValues.Filters.City
            && workflowOrdersFilterValues.Filters.City.length > 0) {
            actions.change('schedule-ordersFilter', 'Filters.City', workflowOrdersFilterValues.Filters.City);
          } else {
            actions.change('schedule-ordersFilter', 'Filters.City', []);
          }
          if (workflowOrdersFilterValues.Filters.Driver
            && workflowOrdersFilterValues.Filters.Driver.length > 0) {
            actions.change('schedule-ordersFilter', 'Filters.Driver', workflowOrdersFilterValues.Filters.Driver);
          } else {
            actions.change('schedule-ordersFilter', 'Filters.Driver', []);
          }
          if (workflowOrdersFilterValues.Filters.Status
            && workflowOrdersFilterValues.Filters.Status.length > 0) {
            actions.change('schedule-ordersFilter', 'Filters.Status', workflowOrdersFilterValues.Filters.Status);
          } else {
            actions.change('schedule-ordersFilter', 'Filters.Status', []);
          }
          if (workflowOrdersFilterValues.Filters.User
            && workflowOrdersFilterValues.Filters.User.length > 0) {
            actions.change('schedule-ordersFilter', 'Filters.User', workflowOrdersFilterValues.Filters.User);
          } else {
            actions.change('schedule-ordersFilter', 'Filters.User', []);
          }
          if (workflowOrdersFilterValues.Filters.Referral
            && workflowOrdersFilterValues.Filters.Referral.length > 0) {
            actions.change('schedule-ordersFilter', 'Filters.Referral', workflowOrdersFilterValues.Filters.Referral);
          } else {
            actions.change('schedule-ordersFilter', 'Filters.Referral', []);
          }
          if (workflowOrdersFilterValues.Filters.Payer
            && workflowOrdersFilterValues.Filters.Payer.length > 0) {
            actions.change('schedule-ordersFilter', 'Filters.Payer', workflowOrdersFilterValues.Filters.Payer);
          } else {
            actions.change('schedule-ordersFilter', 'Filters.Payer', []);
          }
          if (workflowOrdersFilterValues.Filters.Sales
            && workflowOrdersFilterValues.Filters.Sales.length > 0) {
            actions.change('schedule-ordersFilter', 'Filters.Sales', workflowOrdersFilterValues.Filters.Sales);
          } else {
            actions.change('schedule-ordersFilter', 'Filters.Sales', []);
          }
          if (workflowOrdersFilterValues.Filters.Type
            && workflowOrdersFilterValues.Filters.Type.length > 0) {
            actions.change('schedule-ordersFilter', 'Filters.Type', workflowOrdersFilterValues.Filters.Type);
          } else {
            actions.change('schedule-ordersFilter', 'Filters.Type', []);
          }
        } else {
          actions.clearFields('schedule-ordersFilter', 'Filters');
        }
      } else {
        actions.change('schedule-ordersFilter', 'variant', variant);
        actions.change('schedule-ordersFilter', 'Date of Delivery From', dateOfDeliveryFrom);
        actions.change('schedule-ordersFilter', 'Date of Delivery To', dateOfDeliveryTo);
        actions.change('schedule-ordersFilter', 'Filters.Date of Delivery', [{
          value: `${dateOfDeliveryFrom}-${dateOfDeliveryTo}`,
          label: `${dateOfDeliveryFrom}-${dateOfDeliveryTo}`,
        }]);
        history.replace(`${location.pathname}${datesOfDeliveryParams}`);
      }
    }
  }

  componentDidMount() {
    const { actions } = this.props;
    this.onRequest();
    actions.fetchUsers({
      filters: [
        {
          name: 'Role',
          operation: 'eq',
          val: 'Driver',
        },
        {
          name: 'Active',
          operation: 'eq',
          val: 'true',
        },
      ],
      triggerLoading: true,
    });
    actions.fetchBusiness({
      triggerLoading: false,
    });
    window.addEventListener('resize', this.onWindowResize);
    window.addEventListener('message', this.onWindowMessage);
  }

  componentWillReceiveProps(nextProps) {
    const { filters, connectedOrdersOrderLineID } = this.props;
    const nextOrderState = nextProps.filters['Workflow State']
      ? nextProps.filters['Workflow State'].join('')
      : null;
    const currentOrderState = filters['Workflow State']
      ? filters['Workflow State'].join('')
      : null;
    const nextIsRejected = nextProps.filters['Is Rejected']
      ? nextProps.filters['Is Rejected'].join('')
      : null;
    const currentIsRejected = filters['Is Rejected']
      ? filters['Is Rejected'].join('')
      : null;
    const nextAssignedUserID = nextProps.filters['Assigned User ID']
      ? nextProps.filters['Assigned User ID'].join('')
      : null;
    const currentAssignedUserID = filters['Assigned User ID']
      ? filters['Assigned User ID'].join('')
      : null;
    const nextStatus = nextProps.filters.Status
      ? nextProps.filters.Status.join('')
      : null;
    const currentStatus = filters.Status
      ? filters.Status.join('')
      : null;
    const nextDriverID = nextProps.filters['Driver ID']
      ? nextProps.filters['Driver ID'].join('')
      : null;
    const currentDriverID = filters['Driver ID']
      ? filters['Driver ID'].join('')
      : null;
    const nextCity = nextProps.filters.City
      ? nextProps.filters.City.join('')
      : null;
    const currentCity = filters.City
      ? filters.City.join('')
      : null;
    const nextSalesID = nextProps.filters['Sales Representative ID']
      ? nextProps.filters['Sales Representative ID'].join('')
      : null;
    const currentSalesID = filters['Sales Representative ID']
      ? filters['Sales Representative ID'].join('')
      : null;
    const nextLineType = nextProps.filters['Line Type']
      ? nextProps.filters['Line Type'].join('')
      : null;
    const currentLineType = filters['Line Type']
      ? filters['Line Type'].join('')
      : null;
    const nextReferralID = nextProps.filters['Referral Source ID']
      ? nextProps.filters['Referral Source ID'].join('')
      : null;
    const currentReferralID = filters['Referral Source ID']
      ? filters['Referral Source ID'].join('')
      : null;
    const nextInsuranceInfoID = nextProps.filters['Insurance Info ID']
      ? nextProps.filters['Insurance Info ID'].join('')
      : null;
    const currentInsuranceInfoID = filters['Insurance Info ID']
      ? filters['Insurance Info ID'].join('')
      : null;
    const nextPrescriberID = nextProps.filters['Prescriber ID']
      ? nextProps.filters['Prescriber ID'].join('')
      : null;
    const currentPrescriberID = filters['Prescriber ID']
      ? filters['Prescriber ID'].join('')
      : null;
    const nextHCPCSCodeID = nextProps.filters['HCPC S Code ID']
      ? nextProps.filters['HCPC S Code ID'].join('')
      : null;
    const currentHCPCSCodeID = filters['HCPC S Code ID']
      ? filters['HCPC S Code ID'].join('')
      : null;
    const nextWatcherID = nextProps.filters['Watcher ID']
      ? nextProps.filters['Watcher ID'].join('')
      : null;
    const currentWatcherID = filters['Watcher ID']
      ? filters['Watcher ID'].join('')
      : null;
    const nextPatientID = nextProps.filters['Patient ID']
      ? nextProps.filters['Patient ID'].join('')
      : null;
    const currentPatientID = filters['Patient ID']
      ? filters['Patient ID'].join('')
      : null;
    const filtersChanged = nextProps.filters['Patient Date of Birth'] !== filters['Patient Date of Birth']
      || nextProps.filters['Order ID'] !== filters['Order ID']
      || nextProps.filters['Insurance Code'] !== filters['Insurance Code']
      || nextProps.filters['Claim Code'] !== filters['Claim Code']
      || nextProps.filters['Date of Service From'] !== filters['Date of Service From']
      || nextProps.filters['Date of Service To'] !== filters['Date of Service To']
      || nextProps.filters['Date of Creation From'] !== filters['Date of Creation From']
      || nextProps.filters['Date of Creation To'] !== filters['Date of Creation To']
      || nextProps.filters['Date of Claim Submission From'] !== filters['Date of Claim Submission From']
      || nextProps.filters['Date of Claim Submission To'] !== filters['Date of Claim Submission To']
      || nextPatientID !== currentPatientID
      || nextOrderState !== currentOrderState
      || nextIsRejected !== currentIsRejected
      || nextAssignedUserID !== currentAssignedUserID
      || nextStatus !== currentStatus
      || nextDriverID !== currentDriverID
      || nextCity !== currentCity
      || nextSalesID !== currentSalesID
      || nextLineType !== currentLineType
      || nextInsuranceInfoID !== currentInsuranceInfoID
      || nextReferralID !== currentReferralID
      || nextPrescriberID !== currentPrescriberID
      || nextHCPCSCodeID !== currentHCPCSCodeID
      || nextWatcherID !== currentWatcherID;

    if (nextProps.connectedOrdersOrderLineID.length > 0
      && JSON.stringify(nextProps.connectedOrdersOrderLineID)
      !== JSON.stringify(connectedOrdersOrderLineID)) {
      this.props.actions.clearConnectedOrders();
    }

    if (nextProps.filters['Date of Delivery From']
      && nextProps.filters['Date of Delivery To']
      && !validate.date(nextProps.filters['Date of Delivery From'])
      && !validate.date(nextProps.filters['Date of Delivery To'])
      && !moment(nextProps.filters['Date of Delivery To'], dateFormat)
        .isBefore(moment(nextProps.filters['Date of Delivery From'], dateFormat))
      && (nextProps.filters['Date of Delivery From'] !== filters['Date of Delivery From']
      || nextProps.filters['Date of Delivery To'] !== filters['Date of Delivery To'])) {
      this.setState({
        'Date of Delivery From': moment(nextProps.filters['Date of Delivery From'], dateFormat).format(dateFormat),
        'Date of Delivery To': moment(nextProps.filters['Date of Delivery To'], dateFormat).format(dateFormat),
        offset: 0,
      });
    } else if (!nextProps.filters['Date of Delivery From']
      && !nextProps.filters['Date of Delivery To']
      && filters['Date of Delivery From']
      && filters['Date of Delivery To']) {
      this.setState({
        'Date of Delivery From': null,
        'Date of Delivery To': null,
        offset: 0,
      });
    }

    if (filtersChanged) {
      this.setState({ offset: 0 });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return ((Object.keys(objectDiff(this.props, nextProps)).length +
      Object.keys(objectDiff(this.state, nextState)).length) > 0);
  }

  componentDidUpdate(prevProps, prevState) {
    const { filters, history, location, orders, count, loading } = this.props;
    const { limit, offset } = this.state;
    const limitChanged = prevState.limit !== limit;
    const offsetChanged = prevState.offset !== offset;
    const datesOfDeliveryChanged = prevState['Date of Delivery From'] !== this.state['Date of Delivery From']
      || prevState['Date of Delivery To'] !== this.state['Date of Delivery To'];
    const { throttledFiltersChanged, filtersChanged: filterPropsChanged } = getFilterChangeTypes(
      prevProps.filters,
      filters,
      {
        textFilterKeys: ['Order ID', 'Insurance Code', 'Claim Code'],
        immediateFilterKeys: [
          'Patient Date of Birth',
          'Date of Service From',
          'Date of Service To',
          'Date of Creation From',
          'Date of Creation To',
          'Date of Claim Submission From',
          'Date of Claim Submission To',
        ],
        arrayFilterKeys: [
          'Patient ID',
          'Workflow State',
          'Assigned User ID',
          'Status',
          'Is Rejected',
          'Driver ID',
          'City',
          'Sales Representative ID',
          'Insurance Info ID',
          'Line Type',
          'Referral Source ID',
          'Prescriber ID',
          'HCPC S Code ID',
          'Watcher ID',
        ],
      },
    );
    const filtersChanged = filterPropsChanged || datesOfDeliveryChanged;
    if (datesOfDeliveryChanged) {
      let datesOfDeliveryParams;
      if (this.state['Date of Delivery From'] && this.state['Date of Delivery To']) {
        datesOfDeliveryParams = qs.stringify({
          from: this.state['Date of Delivery From'],
          to: this.state['Date of Delivery To'],
        }, {
          encode: false, addQueryPrefix: true,
        });
      } else {
        datesOfDeliveryParams = '';
      }
      if (!location.search || location.search !== datesOfDeliveryParams) {
        history.replace(`${location.pathname}${datesOfDeliveryParams}`);
      }
    }
    if (throttledFiltersChanged) {
      this.onThrottledRequest();
    } else if (limitChanged || offsetChanged || filtersChanged) {
      this.onRequest();
    } else if (orders.length < count
      && loading === 0) {
      this.onSequenceRequest();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
    window.removeEventListener('message', this.onWindowMessage);
    document.querySelector('html').classList.remove('page-schedule');
  }

  onRequest(options = {}) {
    const { actions, filters } = this.props;
    const { limit, offset } = this.state;

    if (this.state['Date of Delivery From']) {
      filters['Date of Delivery From'] = this.state['Date of Delivery From'];
    } else {
      delete filters['Date of Delivery From'];
    }
    if (this.state['Date of Delivery To']) {
      filters['Date of Delivery To'] = this.state['Date of Delivery To'];
    } else {
      delete filters['Date of Delivery To'];
    }
    const requestFilters = filters && Object.keys(filters).length > 0
      ? Object.keys(filters).map((key) => {
        let name = key;
        let operation;
        let caseSensitivity = null;
        let val = filters[key];
        switch (key) {
          case 'Workflow State':
            name = 'Workflow State ID';
            if (filters[key].length > 1) {
              operation = 'in';
            } else {
              operation = 'eq';
              val = filters[key][0];
            }
            break;
          case 'Is Rejected':
            if (filters[key].length > 1) {
              operation = 'in';
            } else {
              operation = 'eq';
              val = filters[key][0];
            }
            break;
          case 'Patient ID':
            operation = 'in';
            break;
          case 'Order ID':
            name = 'ID';
            operation = 'eq';
            break;
          case 'Date of Birth':
            operation = 'eq';
            break;
          case 'Insurance Code':
            operation = 'startswith';
            caseSensitivity = false;
            break;
          case 'Claim Code':
            operation = 'startswith';
            caseSensitivity = false;
            break;
          case 'Status':
            name = 'Workflow Status ID';
            operation = 'in';
            break;
          case 'Assigned User ID':
          case 'Driver ID':
          case 'Sales Representative ID':
          case 'Prescriber ID':
          case 'City':
          case 'HCPC S Code ID':
          case 'Watcher ID':
            operation = 'in';
            break;
          case 'Date of Service From':
            name = 'Date of Service';
            operation = 'ge';
            break;
          case 'Date of Service To':
            name = 'Date of Service';
            operation = 'le';
            break;
          case 'Date of Creation':
            name = 'Date of Creation';
            operation = 'eq';
            break;
          case 'Date of Creation From':
            name = 'Date of Creation';
            operation = 'ge';
            break;
          case 'Date of Creation To':
            name = 'Date of Creation';
            operation = 'le';
            break;
          case 'Date of Delivery From':
            name = 'Date of Delivery';
            operation = 'ge';
            break;
          case 'Date of Delivery To':
            name = 'Date of Delivery';
            operation = 'le';
            break;
          case 'Date of Claim Submission From':
            name = 'Claim Create At';
            operation = 'ge';
            break;
          case 'Date of Claim Submission To':
            name = 'Claim Create At';
            operation = 'le';
            break;
          default:
            operation = 'startswith';
            caseSensitivity = false;
        }
        return {
          name,
          operation,
          val,
          ...caseSensitivity !== null ? { case_sensitivity: caseSensitivity } : {},
        };
      })
      : null;
    actions.fetchOrders({
      filters: requestFilters,
      triggerLoading: options.triggerLoading !== undefined ? options.triggerLoading : true,
      limit: options.limit !== undefined ? options.limit : limit,
      offset: options.offset !== undefined ? options.offset : offset,
      push: options.push !== undefined ? options.push : offset > 0,
      sortBy: [{
        name: 'Date of Delivery',
        sort: 'asc',
      }],
      show_schema_name: 'schedule_order_schema',
    });
  }

  onScheduleCalendarHorizontalScroll(event) {
    this.setState({ horizontalScroll: event.target.scrollLeft });
  }

  onToolbarResize({ expandedView, expansionDetailsHeight }) {
    this.setState({
      toolbarExpanded: expandedView,
      toolbarHeight: expansionDetailsHeight,
    });
  }

  onSequenceRequest() {
    const { limit, offset } = this.state;
    this.setState({ offset: offset + limit });
  }

  getSchedules(items) {
    const dateFromMoment = moment(this.state['Date of Delivery From'], dateFormat);
    const dateToMoment = moment(this.state['Date of Delivery To'], dateFormat);
    const numberOfDays = dateToMoment.diff(dateFromMoment, 'days') + 1;
    let schedules;
    if (numberOfDays === 1) {
      schedules = items.reduce((accumulator, currentValue) => {
        const itemsWithDeliveries = currentValue.items
          .filter(item => item.items.length > 0);
        if (itemsWithDeliveries.length > 0) {
          const concatedItems = itemsWithDeliveries
            .reduce((nestedAccumulator, nestedCurrentValue) => ([
              ...nestedAccumulator,
              ...nestedCurrentValue.items,
            ]), []);
          return [
            ...accumulator,
            concatedItems,
          ];
        }
        return accumulator;
      }, []);
    } else {
      schedules = items.reduce((accumulator, currentValue) => {
        const itemsWithDeliveries = currentValue.items
          .filter(item => item.items.length > 0);
        if (itemsWithDeliveries.length > 0) {
          const concatedItems = itemsWithDeliveries
            .reduce((nestedAccumulator, nestedCurrentValue) => ([
              ...nestedAccumulator,
              ...nestedCurrentValue.items,
            ]), []);
          const itemsGroupedByDriver = groupBy(concatedItems, '["Order Line"][0].Driver.ID');
          return [
            ...accumulator,
            ...Object.keys(itemsGroupedByDriver).map(key => itemsGroupedByDriver[key]),
          ];
        }
        return accumulator;
      }, []);
    }

    return schedules;
  }

  onWindowMessage(event) {
    const { actions } = this.props;
    if (event.data.type && event.data.type === 'order-update-success' && event.data.values && event.data.values.data) {
      Object.keys(event.data.values.data).forEach((orderID) => {
        actions.updateOrderSuccess(event.data.values.data[orderID]);
      });
      actions.addNotification({
        message: 'Order successfully updated',
        variant: 'success',
      });
    }
  }

  render() {
    const {
      variant,
      orders,
      loading,
      driversLoading,
      history,
      contextFiltersOptions,
      submitting,
      filters,
      business,
      tabID,
      width,
      classes,
    } = this.props;
    const {
      horizontalScroll,
      toolbarExpanded,
      toolbarHeight,
      offset,
      limit,
    } = this.state;
    const allDrivers = [
      ...this.props.drivers,
      {
        ID: null,
        'First Name': 'Driver',
        'Last Name': 'not assigned',
      },
    ];
    const filteredDrivers = filters['Driver ID'] && filters['Driver ID'].length > 0
      ? allDrivers.filter(driver => filters['Driver ID'].indexOf(driver.ID) !== -1)
      : allDrivers;
    let items = [];
    let numberOfDays;
    let dateFrom = this.state['Date of Delivery From'];
    let dateTo = this.state['Date of Delivery To'];
    if (!dateFrom && orders.length > 0 && orders[orders.length - 1]['Order Line'][0]['Date of Delivery']) {
      dateFrom = moment(orders[0]['Order Line'][0]['Date of Delivery'], timeDateFormat).format(dateFormat);
      dateTo = moment(orders[orders.length - 1]['Order Line'][0]['Date of Delivery'], timeDateFormat).format(dateFormat);
    }
    if (dateFrom) {
      const dateFromMoment = moment(dateFrom, dateFormat);
      const dateToMoment = moment(dateTo, dateFormat);
      numberOfDays = Math.abs(dateToMoment.diff(dateFromMoment, 'days')) + 1;
      if (numberOfDays === 1) {
        const drivers = filteredDrivers.map(item => ({
          ...item,
          items: [...new Array(24)].map((halfHour, halfHourIndex) => {
            const hour = 8 + Math.floor(halfHourIndex / 2);
            const minute = (halfHourIndex % 2) * 30;
            const halfHourMoment = dateFromMoment.clone().hours(hour).minutes(minute);
            return {
              date: halfHourMoment.format(timeDateFormat),
              ID: `${item.ID}-${halfHourMoment.valueOf()}`,
              items: [],
            };
          }),
        }));
        items = orders.reduce((driversAccumulator, currentOrder) => {
          const orderLineByDriver = groupBy(currentOrder['Order Line'], 'Driver.ID');
          return Object.keys(orderLineByDriver).reduce((accumulator, driverID) => (
            accumulator.map((driver) => {
              if (driverID !== 'undefined' && driver.ID !== Number(driverID)) {
                return driver;
              }
              if (driverID === 'undefined' && driver.ID !== null) {
                return driver;
              }
              const orderLineByDriverByDateOfDelivery =
                groupBy(orderLineByDriver[driverID], 'Date of Delivery');
              return {
                ...driver,
                items: driver.items.map((halfHour) => {
                  let newHalfHour = { ...halfHour };
                  const halfHourStartMoment = moment(halfHour.date, timeDateFormat);
                  const halfHourEndMoment = halfHourStartMoment.clone().add(29, 'minutes');
                  const halfHourRange = moment.range(halfHourStartMoment, halfHourEndMoment);
                  Object.keys(orderLineByDriverByDateOfDelivery).forEach((dateOfDelivery) => {
                    const dateOfDeliveryMoment = moment(dateOfDelivery, timeDateFormat);
                    if (halfHourRange.contains(dateOfDeliveryMoment)) {
                      const orderLineByDriverByDateOfDeliveryByIsDelivered =
                        groupBy(orderLineByDriverByDateOfDelivery[dateOfDelivery], 'Is Delivered');
                      let newItems = [];
                      if (orderLineByDriverByDateOfDeliveryByIsDelivered.true) {
                        newItems = [{
                          ...currentOrder,
                          ID: `${orderLineByDriverByDateOfDelivery[dateOfDelivery]
                            .map(orderLine => orderLine.ID).join('-')}-Is-Delivered-True`,
                          'Order Line': orderLineByDriverByDateOfDeliveryByIsDelivered.true,
                        }];
                      }
                      if (orderLineByDriverByDateOfDeliveryByIsDelivered.false) {
                        newItems = [
                          ...newItems,
                          {
                            ...currentOrder,
                            ID: `${orderLineByDriverByDateOfDelivery[dateOfDelivery]
                              .map(orderLine => orderLine.ID).join('-')}-Is-Delivered-False`,
                            'Order Line': orderLineByDriverByDateOfDeliveryByIsDelivered.false,
                          },
                        ];
                      }
                      newHalfHour = {
                        ...newHalfHour,
                        items: [
                          ...newHalfHour.items,
                          ...newItems,
                        ],
                      };
                    }
                  });
                  return newHalfHour;
                }),
              };
            })
          ), driversAccumulator);
        }, drivers);
      } else {
        const days = [...new Array(numberOfDays)].map((item, index) => {
          const weekDayMoment = dateFromMoment.clone().add(index, 'days');
          return {
            date: weekDayMoment.format(dateFormat),
            ID: weekDayMoment.valueOf(),
            items: [...new Array(24)].map((halfHour, halfHourIndex) => {
              const hour = 8 + Math.floor(halfHourIndex / 2);
              const minute = (halfHourIndex % 2) * 30;
              const halfHourMoment = weekDayMoment.clone().hours(hour).minutes(minute);
              return {
                date: halfHourMoment.format(timeDateFormat),
                ID: halfHourMoment.valueOf().toString(),
                items: [],
              };
            }),
          };
        });
        items = orders.reduce((weekDaysAccumulator, currentOrder) => {
          let newWeekDaysAccumulator = [...weekDaysAccumulator];
          const orderLineByDateOfDelivery = groupBy(currentOrder['Order Line'], 'Date of Delivery');
          Object.keys(orderLineByDateOfDelivery).forEach((dateOfDelivery) => {
            const dateOfDeliveryMoment = moment(dateOfDelivery, timeDateFormat);
            newWeekDaysAccumulator = newWeekDaysAccumulator.map((weekDay) => {
              const weekDayStartMoment = moment(weekDay.date, dateFormat);
              const weekDayEndMoment = weekDayStartMoment.clone().add({ hours: 23, minutes: 59 });
              const weekDayRange = moment.range(weekDayStartMoment, weekDayEndMoment);
              if (weekDayRange.contains(dateOfDeliveryMoment)) {
                return {
                  ...weekDay,
                  items: weekDay.items.map((halfHour) => {
                    let newHalfHour = { ...halfHour };
                    const halfHourStartMoment = moment(halfHour.date, timeDateFormat);
                    const halfHourEndMoment = halfHourStartMoment.clone().add(29, 'minutes');
                    const halfHourRange = moment.range(halfHourStartMoment, halfHourEndMoment);
                    if (halfHourRange.contains(dateOfDeliveryMoment)) {
                      const orderLineByDateOfDeliveryByDriver =
                        groupBy(orderLineByDateOfDelivery[dateOfDelivery], 'Driver.ID');
                      Object.keys(orderLineByDateOfDeliveryByDriver).forEach((driverID) => {
                        const orderLineByDateOfDeliveryByDriverByIsDelivered =
                          groupBy(orderLineByDateOfDeliveryByDriver[driverID], 'Is Delivered');
                        let newItems = [];
                        if (orderLineByDateOfDeliveryByDriverByIsDelivered.true) {
                          newItems = [{
                            ...currentOrder,
                            ID: `${orderLineByDateOfDeliveryByDriver[driverID]
                              .map(orderLine => orderLine.ID).join('-')}-Is-Delivered-True`,
                            'Order Line': orderLineByDateOfDeliveryByDriverByIsDelivered.true,
                          }];
                        }
                        if (orderLineByDateOfDeliveryByDriverByIsDelivered.false) {
                          newItems = [
                            ...newItems,
                            {
                              ...currentOrder,
                              ID: `${orderLineByDateOfDeliveryByDriver[driverID]
                                .map(orderLine => orderLine.ID).join('-')}-Is-Delivered-False`,
                              'Order Line': orderLineByDateOfDeliveryByDriverByIsDelivered.false,
                            },
                          ];
                        }
                        newHalfHour = {
                          ...newHalfHour,
                          items: [
                            ...newHalfHour.items,
                            ...newItems,
                          ],
                        };
                      });
                    }
                    return newHalfHour;
                  }),
                };
              }
              return weekDay;
            });
          });
          return newWeekDaysAccumulator;
        }, days);
      }
    }
    return (
      <Layout>
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Schedule
          </title>
        </Helmet>
        <StickyToolbar>
          <NavigationFilter
            form={`${tabID}-workflowNavigationFilter`}
            variant="delivery-schedule"
            initialValues={{
              Delivery: true,
            }}
            destroyOnUnmount={false}
          />
          <OrdersFilter
            variant="schedule"
            form="schedule-ordersFilter"
            destroyOnUnmount={false}
            contextFiltersOptions={contextFiltersOptions ? {
              ...contextFiltersOptions,
              drivers: allDrivers.map((driversItem) => {
                const driverInContextFiltersOptions = contextFiltersOptions.drivers.filter(item =>
                  item.ID === driversItem.ID)[0];
                if (driverInContextFiltersOptions) {
                  return driverInContextFiltersOptions;
                }
                return driversItem;
              }),
            } : null}
            onExpansionChange={this.onToolbarResize}
          />
          {driversLoading === 0 &&
            <ScheduleCalendarFilter
              form="schedule-ordersFilter"
              destroyOnUnmount={false}
              variant={numberOfDays === 1 ? 'single-date' : 'date-range'}
              onChange={(values, dispatch, props, prevValues) => {
                if (values.variant && prevValues.variant !== values.variant) {
                  history.push(`/workflow/delivery/schedule/${values.variant}`);
                }
              }}
              onSubmit={(values, dispatch) => {
                let schedules = this.getSchedules(items);
                let patients;
                const patientRecordNumbers = uniq(schedules
                  .reduce((accumulator, currentValue) =>
                    ([
                      ...accumulator,
                      ...currentValue.map(item => item.Patient['Record Number']),
                    ]), []));
                return new Promise((resolve, reject) => {
                  dispatch(fetchPatients({
                    filters: [{
                      name: 'Record Number',
                      operation: 'in',
                      val: patientRecordNumbers,
                    }],
                    sort_by: [{
                      name: 'Record Number',
                      sort: 'asc',
                    }],
                    triggerLoading: true,
                    resolve,
                    reject,
                  }));
                }).then(res => new Promise((resolve, reject) => {
                  patients = res;
                  dispatch(fetchPatientGlobalNotes({
                    values: {
                      'Record Number': patientRecordNumbers,
                      'Is Delivery': true,
                    },
                    triggerLoading: true,
                    resolve,
                    reject,
                  }));
                })).then((res) => {
                  patients = patients.map(item => ({
                    ...item,
                    'Patient Global Notes': res.find(resItem =>
                      resItem['Record Number'] === item['Record Number'])['Patient Global Notes'],
                  }));
                  schedules = schedules.map(schedule => schedule.map(item => ({
                    ...item,
                    Patient: {
                      ...item.Patient,
                      ...patients.filter(patientsItem => patientsItem['Record Number'] === item.Patient['Record Number'])[0],
                    },
                  })));
                  this.props.actions.clearPatients();
                  return schedules.reduce((accumulator, currentValue) => (
                    accumulator.then(prevPDF => scheduleToPDF({
                      inputPDF: prevPDF,
                      schedule: currentValue,
                    }))
                  ), Promise.resolve());
                });
              }}
              onSubmitSuccess={(values) => {
                const blob = values.output('blob');
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                  window.navigator.msSaveOrOpenBlob(blob, 'schedule.pdf');
                } else {
                  printPdf(blob);
                }
              }}
              disabled={loading > 0}
              onEditPreviewButtonClick={() => {
                const schedules = this.getSchedules(items);
                const firstDriver = schedules[0][0]['Order Line'][0].Driver;
                const firstDayOfDelivery = moment(schedules[0][0]['Order Line'][0]['Date of Delivery'], timeDateFormat)
                  .format('MM-DD-YYYY');
                history.push({
                  pathname: `/workflow/delivery/schedule/${variant}/print/${firstDriver.ID || 'unassigned'}/${firstDayOfDelivery}`,
                  state: {
                    items: schedules,
                  },
                });
              }}
              horizontalScroll={horizontalScroll}
              printDisabled={orders.length === 0}
            />
          }
        </StickyToolbar>
        {((loading + driversLoading) > 0 || submitting) &&
          <Progress fixed />
        }
        <ExpansionPanel
          className={classes.expansionPanel}
          elevation={0}
          expanded={toolbarExpanded}
        >
          <ExpansionPanelDetails
            className={classes.expansionPanelDetails}
          >
            <div
              style={{
                height: toolbarHeight,
              }}
            />
          </ExpansionPanelDetails>
        </ExpansionPanel>
        {(driversLoading === 0 && items.length > 0) &&
          <div
            style={{
              paddingTop: width === 'xs' ? 79 : 214,
            }}
          >
            <ScheduleCalendar
              items={items}
              orders={orders}
              filteredDrivers={filteredDrivers}
              variant={numberOfDays === 1 ? 'single-date' : 'date-range'}
              loading={loading > 0}
              onHorizontalScroll={this.onScheduleCalendarHorizontalScroll}
              onOrderLinesUpdate={() => {
                if (variant === 'day') {
                  this.onRequest({
                    push: false,
                    offset: 0,
                    limit: offset + limit,
                  });
                }
              }}
              business={business}
            />
          </div>
        }
        {(loading === 0 && driversLoading === 0 && items.length === 0) && (
          <div
            style={{
              paddingTop: 214,
            }}
          >
            <Paper className={classes.paperOrdersEmpty}>
              <OrdersTableEmpty />
            </Paper>
          </div>
        )}
      </Layout>
    );
  }
}

DeliverySchedule.propTypes = {
  variant: PropTypes.oneOf(['day', 'week', 'month', 'range']),
  orders: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })).isRequired,
  drivers: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })),
  connectedOrdersOrderLineID: PropTypes.arrayOf(PropTypes.number),
  count: PropTypes.number.isRequired,
  loading: PropTypes.number.isRequired,
  driversLoading: PropTypes.number.isRequired,
  filters: PropTypes.shape({
    'Patient ID': PropTypes.arrayOf(PropTypes.number),
    'Patient Date of Birth': PropTypes.string,
    'Order ID': PropTypes.string,
    'Insurance Code': PropTypes.string,
    'Claim Code': PropTypes.string,
    'Assigned User ID': PropTypes.arrayOf(PropTypes.number),
    Status: PropTypes.arrayOf(PropTypes.number),
    'Workflow State': PropTypes.arrayOf(PropTypes.number),
    'Is Rejected': PropTypes.arrayOf(PropTypes.bool),
    'Driver ID': PropTypes.arrayOf(PropTypes.number),
    'Sales Representative ID': PropTypes.arrayOf(PropTypes.number),
    'City': PropTypes.arrayOf(PropTypes.string),
    'Date of Service From': PropTypes.string,
    'Date of Service To': PropTypes.string,
    'Date of Creation From': PropTypes.string,
    'Date of Creation To': PropTypes.string,
    'Date of Delivery From': PropTypes.string,
    'Date of Delivery To': PropTypes.string,
    'Date of Claim Submission From': PropTypes.string,
    'Date of Claim Submission To': PropTypes.string,
    'Insurance Info ID': PropTypes.arrayOf(PropTypes.number),
    'Referral Source ID': PropTypes.arrayOf(PropTypes.number),
    'Line Type': PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  workflowOrdersFilterValues: PropTypes.shape({
    Filters: PropTypes.shape({
      'Date of Delivery': PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
      })),
    }),
  }),
  actions: PropTypes.shape({
    fetchOrders: PropTypes.func.isRequired,
    clearOrders: PropTypes.func.isRequired,
    clearConnectedOrders: PropTypes.func.isRequired,
    fetchUsers: PropTypes.func.isRequired,
    clearUsers: PropTypes.func.isRequired,
    clearPatients: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    clearFields: PropTypes.func.isRequired,
    fetchBusiness: PropTypes.func.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  contextFiltersOptions: PropTypes.shape({
    statuses: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      count: PropTypes.number,
    })).isRequired,
    orderLineTypes: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      count: PropTypes.number,
    })).isRequired,
  }),
  submitting: PropTypes.bool.isRequired,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  tabID: PropTypes.number.isRequired,
  classes: PropTypes.shape({
    expansionPanelDetails: PropTypes.string.isRequired,
  }).isRequired,
};

DeliverySchedule.defaultProps = {
  connectedOrdersOrderLineID: [],
  drivers: [],
  variant: 'day',
  contextFiltersOptions: null,
  workflowOrdersFilterValues: {},
  business: {},
};

const mapStateToProps = (store, ownProps) => {
  const ordersFilterValues = getFormValues('schedule-ordersFilter')(store);
  const workflowOrdersFilterValues = getFormValues(`${store.tabID}-workflow-ordersFilter`)(store);
  const navigationFormValues = getFormValues(`${store.tabID}-workflowNavigationFilter`)(store);

  const State = [
    ...navigationFormValues
      && navigationFormValues.Intake ? [1] : [],
    ...navigationFormValues
      && navigationFormValues.Delivery ? [2] : [],
    ...navigationFormValues
      && navigationFormValues.Billing ? [3] : [],
    ...navigationFormValues
      && navigationFormValues.Collection ? [4] : [],
    ...navigationFormValues
      && navigationFormValues.Paid ? [5] : [],
  ];
  const orderAssignedDrivers = uniqBy(store.orders.data.reduce((accumulator, currentValue) => ([
    ...accumulator,
    ...currentValue['Order Line'].map(orderLine => orderLine.Driver).filter(item => item.ID),
  ]), []), 'ID');
  const inactiveOrderAssignedDrivers = orderAssignedDrivers.filter(orderDriversItem =>
    store.users.data.findIndex(driversItem => driversItem.ID === orderDriversItem.ID) === -1);
  return {
    orders: store.orders.data,
    connectedOrdersOrderLineID: store.connectedOrders.orderLineID,
    drivers: [
      ...store.users.data,
      ...inactiveOrderAssignedDrivers.map(item => ({
        ...item,
        Active: false,
      }))
    ],
    contextFiltersOptions: store.orders.contextFiltersOptions,
    filters: {
      'Workflow State': State.length > 0 ? State : [1],
      ...navigationFormValues
        && navigationFormValues.Rejected
        && State.length === 0
        ? {
          'Is Rejected': [true],
          'Workflow State': [1, 2, 3, 4, 5],
        } : {},
      ...navigationFormValues
        && !navigationFormValues.Rejected
        && State.length === 0
        ? {
          'Is Rejected': [false],
          'Workflow State': [1, 2, 3, 4, 5],
        } : {},
      ...navigationFormValues
        && navigationFormValues.Rejected
        && State.length > 0
        ? { 'Is Rejected': [true, false] } : {},
      ...ordersFilterValues
        && ordersFilterValues.Patients
        && ordersFilterValues.Patients.length > 0
        ? { 'Patient ID': ordersFilterValues.Patients.map(item => item.value) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues['Patient Date of Birth']
        && !validate.date(ordersFilterValues['Patient Date of Birth'])
        ? { 'Patient Date of Birth': moment(ordersFilterValues['Patient Date of Birth'], dateFormat).format(dateFormat) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues['Order ID']
        ? { 'Order ID': ordersFilterValues['Order ID'] }
        : {},
      ...ordersFilterValues
        && ordersFilterValues['Patient Insurance Code']
        ? { 'Insurance Code': ordersFilterValues['Patient Insurance Code'] }
        : {},
      ...ordersFilterValues
        && ordersFilterValues['Claim Code']
        ? { 'Claim Code': ordersFilterValues['Claim Code'] }
        : {},
      ...ordersFilterValues
        && ordersFilterValues['HCPC Code']
        && ordersFilterValues['HCPC Code'].length > 0
        && (!store.orders.contextFiltersOptions
          || store.orders.contextFiltersOptions.hcpcsCodes.filter(item =>
            ordersFilterValues['HCPC Code'].filter(filterItem => filterItem.value === item.ID).length === 0).length > 0)
        ? { 'HCPC S Code ID': ordersFilterValues['HCPC Code'].map(item => item.value) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.City
        && ordersFilterValues.City.length > 0
        && (!store.orders.contextFiltersOptions
          || store.orders.contextFiltersOptions.cities.filter(item =>
            ordersFilterValues.City.filter(filterItem => filterItem.value === item.name).length === 0).length > 0)
        ? { 'City': ordersFilterValues.City.map(item => item.value) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters.User
        && ordersFilterValues.Filters.User.length > 0
        && (!store.orders.contextFiltersOptions
          || store.orders.contextFiltersOptions.users.filter(item =>
            ordersFilterValues.Filters.User.filter(filterItem => filterItem.value === item.ID).length === 0).length > 0)
        ? { 'Assigned User ID': ordersFilterValues.Filters.User.map(item => item.value) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters.Status
        && ordersFilterValues.Filters.Status.length > 0
        && (!store.orders.contextFiltersOptions
          || store.orders.contextFiltersOptions.statuses.filter(item =>
            ordersFilterValues.Filters.Status.filter(filterItem => filterItem.value === item.ID).length === 0).length > 0)
        ? { Status: ordersFilterValues.Filters.Status.map(item => item.value) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters.Driver
        && ordersFilterValues.Filters.Driver.length > 0
        && (!store.orders.contextFiltersOptions
          || store.orders.contextFiltersOptions.drivers.filter(item =>
            ordersFilterValues.Filters.Driver.filter(filterItem => filterItem.value === item.ID).length === 0).length > 0)
        ? { 'Driver ID': ordersFilterValues.Filters.Driver.map(item => item.value) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters.Payer
        && ordersFilterValues.Filters.Payer.length > 0
        && (!store.orders.contextFiltersOptions
          || store.orders.contextFiltersOptions.insurances.filter(item =>
            ordersFilterValues.Filters.Payer.filter(filterItem => filterItem.value === item.ID).length === 0).length > 0)
        ? { 'Insurance Info ID': ordersFilterValues.Filters.Payer.map(item => item.value) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters.Watcher
        && ordersFilterValues.Filters.Watcher.length > 0
        && (!store.orders.contextFiltersOptions
          || store.orders.contextFiltersOptions.watchers.filter(item =>
            ordersFilterValues.Filters.Watcher.filter(filterItem => filterItem.value === item.ID).length === 0).length > 0)
        ? { 'Watcher ID': ordersFilterValues.Filters.Watcher.map(item => item.value) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters.Type
        && ordersFilterValues.Filters.Type.length > 0
        && (!store.orders.contextFiltersOptions
          || store.orders.contextFiltersOptions.orderLineTypes.filter(item =>
            ordersFilterValues.Filters.Type.filter(filterItem => filterItem.value === item.name).length === 0).length > 0)
        ? { 'Line Type': ordersFilterValues.Filters.Type.map(item => item.value) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters.Sales
        && ordersFilterValues.Filters.Sales.length > 0
        && (!store.orders.contextFiltersOptions
          || store.orders.contextFiltersOptions.sales.filter(item =>
            ordersFilterValues.Filters.Sales.filter(filterItem => filterItem.value === item.ID).length === 0).length > 0)
        ? { 'Sales Representative ID': ordersFilterValues.Filters.Sales.map(item => item.value) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters.Referral
        && ordersFilterValues.Filters.Referral.length > 0
        && (!store.orders.contextFiltersOptions
          || store.orders.contextFiltersOptions.referralSources.filter(item =>
            ordersFilterValues.Filters.Referral.filter(filterItem => filterItem.value === item.ID).length === 0).length > 0)
        ? { 'Referral Source ID': ordersFilterValues.Filters.Referral.map(item => item.value) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters.Prescriber
        && ordersFilterValues.Filters.Prescriber.length > 0
        && (!store.orders.contextFiltersOptions
          || store.orders.contextFiltersOptions.prescribers.filter(item =>
            ordersFilterValues.Filters.Prescriber.filter(filterItem => filterItem.value === item.ID).length === 0).length > 0)
        ? { 'Prescriber ID': ordersFilterValues.Filters.Prescriber.map(item => item.value) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters['Date of Service']
        && ordersFilterValues.Filters['Date of Service'].length > 0
        ? {
          'Date of Service From': ordersFilterValues.Filters['Date of Service'][0].value.split('-')[0],
          'Date of Service To': ordersFilterValues.Filters['Date of Service'][0].value.split('-')[1],
        }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters['Date of Creation']
        && ordersFilterValues.Filters['Date of Creation'].length > 0
        ? {
          'Date of Creation From': ordersFilterValues.Filters['Date of Creation'][0].value.split('-')[0],
          'Date of Creation To': ordersFilterValues.Filters['Date of Creation'][0].value.split('-')[1],
        }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters['Date of Delivery']
        && ordersFilterValues.Filters['Date of Delivery'].length > 0
        ? {
          'Date of Delivery From': ordersFilterValues.Filters['Date of Delivery'][0].value.split('-')[0],
          'Date of Delivery To': ordersFilterValues.Filters['Date of Delivery'][0].value.split('-')[1],
        }
        : {
          'Date of Delivery From': moment().format(dateFormat),
          'Date of Delivery To': moment().format(dateFormat),
        },
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters['Date of Claim Submission']
        && ordersFilterValues.Filters['Date of Claim Submission'].length > 0
        ? {
          'Date of Claim Submission From': ordersFilterValues.Filters['Date of Claim Submission'][0].value.split('-')[0],
          'Date of Claim Submission To': ordersFilterValues.Filters['Date of Claim Submission'][0].value.split('-')[1],
        }
        : {},
    },
    loading: store.orders.loading,
    count: store.orders.count,
    driversLoading: store.users.loading,
    submitting: isSubmitting(`${ownProps.variant}-scheduleForm`)(store),
    workflowOrdersFilterValues,
    business: store.business.data,
    tabID: store.tabID,
    appInfo: store.appInfo,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchOrders,
    clearOrders,
    updateOrderSuccess,
    clearConnectedOrders,
    fetchUsers,
    clearUsers,
    clearPatients,
    change,
    reset,
    clearFields,
    fetchBusiness,
    addNotification,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(withWidth()(DeliverySchedule)),
);



// WEBPACK FOOTER //
// ./src/pages/workflow/DeliverySchedule.js